import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { CallbackComponent } from './core/components/callback/callback.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { FitnessGuard } from './core/guards/fitness.guard';
import { DashboardComponent } from './features/dashboard/dashboard/dashboard.component';

const routes: Routes = [
  { path: 'callback', component: CallbackComponent },
  { path: '', component: DashboardComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  {
    path: 'stock',
    loadChildren: () => import('./features/stock/stock.module').then(m => m.StockModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'stats',
    loadChildren: () => import('./features/stats/stats.module').then(m => m.StatsModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'weather',
    loadChildren: () => import('./features/weather/weather.module').then(m => m.WeatherModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'fitness',
    loadChildren: () => import('./features/fitness/fitness.module').then(m => m.FitnessModule),
    canActivate: [AutoLoginPartialRoutesGuard, FitnessGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'user',
    loadChildren: () => import('./features/user/user.module').then(m => m.UserModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
